<template>
	<span
		ref="tooltip"
		class="relative cursor-help z-10"
		v-bind="$attrs"
		@mouseenter="isSelectorDropdownVisible = true"
		@mouseleave="isSelectorDropdownVisible = false"
		@touchstart="handleTouch"
	>
		<slot />
	</span>
	<Transition
		name="fade"
		@before-enter="beforeEnter"
	>
		<div
			v-if="isSelectorDropdownVisible"
			class="bg-background-dark py-2 px-3 text-body-inverse typo-body-caption rounded-md w-full max-w-max z-10"
			:class="[strategy, bubbleClass]"
		>
			<slot name="tooltip" />
			<div
				v-if="rightArrow || downArrow"
				:class="[
					'absolute w-3 h-3 bg-background-dark rotate-45',
					{
						'left-full top-1/2 -translate-y-1/2 -translate-x-3/4': rightArrow,
						'left-1/2 top-full -translate-x-1/2 -translate-y-3/4': downArrow,
					}
				]"
			/>
		</div>
	</Transition>
</template>

<script setup lang="ts">
	import {computePosition, offset, shift, autoPlacement, type Placement, type Strategy} from '@floating-ui/dom';

	type Props = {
		placement?: Placement
		strategy?: Strategy
		rightArrow?: boolean;
		downArrow?: boolean;
		bubbleClass?: string;
	};

	const props = withDefaults(defineProps<Props>(), {
		placement: undefined,
		strategy: 'absolute',
	});

	const tooltip = ref<HTMLElement | null>(null);
	const isSelectorDropdownVisible = ref(false);

	async function beforeEnter(el: Element) {
		const htmlEl = el as HTMLElement;
		const {x, y} = await computePosition(tooltip.value!, htmlEl, {
			strategy: props.strategy,
			middleware: [offset(6), shift(), ...(props.placement ? [] : [autoPlacement()])],
			placement: props.placement,
		});

		Object.assign(htmlEl.style, {
			top: `${y}px`,
			left: `${x}px`,
		});
	}

	function handleTouch(event: TouchEvent) {
		event.stopPropagation();
		isSelectorDropdownVisible.value = true;

		setTimeout(() => {
			isSelectorDropdownVisible.value = false;
		}, 5000);
	}
</script>
